import { Component, Input, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {CommonUtilty, MultiLingualService } from 'app';
import { clientUtil } from 'app/BaseFramework/core/utilities/clientUtil';
import { dateUtil } from 'app/BaseFramework/core/utilities/dateUtil';
import { Constants } from 'app/constants';
import { BaseDataServiceComponent } from '../base-transaction-component/base-data-service.component';
import { imageUtil } from 'app/BaseFramework/core/utilities/imageUtility';
@Component({
  selector: "app-view-profile-summary",
  templateUrl: "./view-profile-summary.component.html",
  styleUrls: ["./view-profile-summary.component.scss"],
})
export class ViewProfileSummaryComponent extends BaseDataServiceComponent implements OnInit {
  _currentComponentName = "ViewProfileSummaryComponent";
  constructor(
    private fb: UntypedFormBuilder,
    public commonUtilty: CommonUtilty,
    public dateUtil: dateUtil,
    public imageUtil: imageUtil,
    public clientUtil: clientUtil,
    public multiLingualService: MultiLingualService,
    public viewContainerRef: ViewContainerRef) {
    super(viewContainerRef);
  }
  Constants = Constants;
  viewProfileSummaryForm: UntypedFormGroup;
  VIEWPROFILESUMMARYFORM = "viewProfileSummaryForm";
  selectedClient: any = [];

  @Input() set IO(value: any) { if (value) this.selectedClient = value; }

  override getCurrentComponentName(): string { return this._currentComponentName }
  
  ngOnInit() {
    if (this.IO != null) this.initializeProfileSummaryForm(this.IO);
  }
  initializeProfileSummaryForm(data?) { this.viewProfileSummaryForm = this.fb.group({}); }
}